import React from "react";
import { Modal, Button } from "react-bootstrap";
const SuccessModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Product Added
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Greetings</h4>
        <p>
          Product Added Successfully
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SuccessModal;
